import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-outer-transfer",
  templateUrl: "./outer-transfer.component.html",
  styleUrls: ["./outer-transfer.component.scss"],
})
export class OuterTransferComponent {
  form = {
    location: "Manyal Elrouda",
    outerTransferCustomerProfile: false,
    search: "",
    customerOuterTransferTo: "",
    outerTransferNote: "",
  };

  constructor(private dialogRef: MatDialogRef<OuterTransferComponent>) {}

  onSearch(): void {
    // handle customer search logic here
  }

  submit(): void {
    this.dialogRef.close(this.form);
  }

  close(): void {
    this.dialogRef.close();
  }
}
